import React from 'react'
import Dialog from '@material-ui/core/Dialog'
import DialogContent from '@material-ui/core/DialogContent'
import { InnrHead } from 'containers'
import { IconButton, makeStyles } from '@material-ui/core'
import CloseIcon from '@material-ui/icons/Close'
import { useUpgradeDialog } from 'contexts/UpgradeDialogContext'
import UpgradeMembershipInfo from './UpgradeMembershipInfo'

const useStyles = makeStyles(() => ({
  dialogContent: {
    padding: 0,
  },
}))

const UpgradeMembershipDialogAlert = () => {
  const classes = useStyles()
  const { isOpen, hideUpgradeDialog } = useUpgradeDialog()

  return (
    <div>
      <Dialog
        open={isOpen}
        onClose={hideUpgradeDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth="sm"
      >
        <InnrHead title="">
          <IconButton onClick={hideUpgradeDialog} size="small">
            <CloseIcon />
          </IconButton>
        </InnrHead>
        <DialogContent className={classes.dialogContent}>
          <UpgradeMembershipInfo />
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default UpgradeMembershipDialogAlert
